"use client";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import { ROUTES } from "@/config/routes";
import LogoHeader from "../LogoHeader";

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const onSignIn = () => navigate(ROUTES.AUTH);
  const onGetStarted = () => navigate(ROUTES.AUTH);

  return (
    <nav className="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left side - logo */}
          <LogoHeader />
          {/* <div className="flex items-center space-x-3 min-w-0">
            <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
              <FileText className="h-5 w-5 text-white" />
            </div>
            <div className="min-w-0">
              <h1 className="text-lg sm:text-xl font-bold text-gray-900 truncate">
                FitMyResume (dev)
              </h1>
              <p className="text-xs text-gray-500 hidden sm:block">
                Job Tailored Resumes
              </p>
            </div>
          </div> */}

          {/* Right side - desktop */}
          <div className="hidden sm:flex items-center space-x-2 sm:space-x-4 ml-2">
            <Button variant="ghost" onClick={() => navigate(ROUTES.TEMPLATES)} className="text-gray-700">
              Templates
            </Button>
            <Button variant="ghost" onClick={() => navigate(ROUTES.PRICING)} className="text-gray-700">
              Pricing
            </Button>
            <Button
              variant="outline"
              onClick={onSignIn}
              className="border-blue-200 text-blue-600 hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 px-4 py-2"
            >
              Sign In
            </Button>
            <Button
              onClick={onGetStarted}
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-md hover:shadow-lg px-6 py-2"
            >
              Get Started Free
            </Button>
          </div>

          {/* Hamburger button - mobile */}
          <div className="sm:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition"
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="sm:hidden px-4 pb-4 space-y-2">
          <Button
            variant="ghost"
            onClick={() => navigate(ROUTES.TEMPLATES)}
            className="w-full justify-start text-gray-700"
          >
            Templates
          </Button>
          <Button
            variant="ghost"
            onClick={() => navigate(ROUTES.PRICING)}
            className="w-full justify-start text-gray-700"
          >
            Pricing
          </Button>
          <Button
            variant="outline"
            onClick={onSignIn}
            className="w-full text-left border-blue-200 text-blue-600 hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 px-4 py-2 rounded-lg"
          >
            Sign In
          </Button>
          <Button
            onClick={onGetStarted}
            className="w-full text-left bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-md hover:shadow-lg px-4 py-2 rounded-lg"
          >
            Get Started Free
          </Button>
        </div>
      )}
    </nav>
  );
}
